import { STORE_PREFERENCE_EVENT } from '@theme/store-routes';

/**
 * Handles store preference changes on product pages by reloading the page.
 * This ensures product prices reflect the new store's catalog pricing.
 */
class ProductPageStoreHandler {
  constructor() {
    this.#init();
  }

  #init() {
    document.addEventListener(STORE_PREFERENCE_EVENT, this.#handleStoreChange);
  }

  /**
   * Handle store preference changes by reloading the page
   * This ensures all prices are fetched fresh from the backend after catalog assignment
   */
  #handleStoreChange = () => {
    // Reload the page to fetch updated prices from the backend
    // The store selector already shows a loading overlay, so this will be seamless
    window.location.reload();
  };
}

// Initialize on product pages
if (document.body.classList.contains('template-product')) {
  new ProductPageStoreHandler();
}
